import {Agent, selfTqk, selfTqo} from "../rpc/webrpc-client.gen.ts";
import {iconForEntityType} from "../fa.tsx";
import {FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {queryOptions} from "@tanstack/react-query";
import {useInfallibleQuery} from "../util/useInfallibleQuery.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function agentRoleIcons(agent: Agent): FontAwesomeIconProps[] {
    const roleIcons: FontAwesomeIconProps[] = [];

    if (agent.canAdmin) {
        roleIcons.push(iconForEntityType("admin"));
    }
    if (agent.canDrive) {
        roleIcons.push(iconForEntityType("driver"));
    }
    if (agent.admitterFor) {
        roleIcons.push(iconForEntityType("admitter"));
    }

    return roleIcons;
}

export function useFullSelf() {
    const mama = useMothership();
    return useInfallibleQuery(queryOptions({
        queryKey: selfTqk,
        queryFn: () => mama.self(),
        select: (rpcfull) => rpcfull.srv,
    }));
}

export function useSelf() {
    const mama = useMothership();
    return useInfallibleQuery({
        ...selfTqo(mama), select: (rpcfull) => rpcfull.srv.self,
    });
}



